import Reveal from "@/components/site/Reveal";

/**
 * BrandExperience — a premium credibility section showing brands that
 * members of the Xadentra team have worked with or supported through
 * their professional careers.
 *
 * IMPORTANT positioning: these are NOT current Xadentra clients. The
 * copy is deliberately worded as team experience, not customer
 * relationships or endorsements.
 *
 * Extending: add a new object to the BRANDS array. Two shapes are
 * supported today; add more branches to <BrandMark /> if needed:
 *   { name: string, type: "svg",       viewBox: string, path: string }
 *   { name: string, type: "wordmark",  text: string, className?: string }
 */

const BRANDS = [
  {
    name: "PayPal",
    type: "svg",
    viewBox: "0 0 24 24",
    // simple-icons (CC0) PayPal mark
    path:
      "M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944.901C5.026.382 5.474 0 5.998 0h7.46c2.57 0 4.578.543 5.69 1.81 1.01 1.15 1.304 2.42 1.012 4.287-.023.143-.047.288-.077.437-.983 5.05-4.349 6.797-8.647 6.797h-2.19c-.524 0-.968.382-1.05.9l-1.12 7.106zm14.146-14.42a3.35 3.35 0 0 0-.607-.541c-.013.076-.026.175-.041.254-.59 3.025-2.566 6.082-8.558 6.082H9.71l-1.128 7.152a.665.665 0 0 0 .657.767h3.917c.526 0 .974-.383 1.057-.902l.038-.176 1.049-6.657.067-.36c.083-.518.532-.9 1.058-.9h.665c4.303 0 7.673-1.746 8.658-6.797a4.86 4.86 0 0 0-.826-4.093z",
  },
  {
    name: "GitHub",
    type: "svg",
    viewBox: "0 0 24 24",
    // simple-icons (CC0) GitHub Octocat mark
    path:
      "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12",
  },
  {
    name: "Adobe",
    type: "svg-combo",
    viewBox: "0 0 24 24",
    // Adobe's iconic red "A" mark (simple-icons CC0)
    path:
      "M13.966 22.624l-1.69-4.281H8.122l3.892-9.144 5.662 13.425zM8.884 1.376H0v21.248zM15.116 1.376L24 22.624V1.376z",
    wordmark: "Adobe",
    wordmarkClassName: "font-display font-semibold tracking-tight",
  },
  {
    name: "Salesforce",
    type: "svg-combo",
    viewBox: "0 0 24 24",
    // Salesforce cloud mark (simple-icons CC0)
    path:
      "M10.006 5.415a4.195 4.195 0 0 1 3.045-1.306c1.56 0 2.954.9 3.69 2.205.63-.3 1.35-.45 2.1-.45 2.85 0 5.159 2.34 5.159 5.22s-2.31 5.22-5.16 5.22c-.345 0-.689-.032-1.005-.093a3.756 3.756 0 0 1-3.3 1.945c-.51 0-1.005-.12-1.44-.34a4.283 4.283 0 0 1-3.977 2.6c-1.32 0-2.564-.63-3.283-1.687a3.978 3.978 0 0 1-.813.09A3.985 3.985 0 0 1 .959 14.855a3.85 3.85 0 0 1 1.83-3.269 4.428 4.428 0 0 1-.402-1.936 4.487 4.487 0 0 1 4.507-4.462c1.54 0 2.902.66 3.75 1.717a4.42 4.42 0 0 1-.638-1.49",
    wordmark: "salesforce",
    wordmarkClassName: "font-serif italic font-semibold tracking-tight lowercase",
  },
  {
    name: "Microsoft",
    type: "svg-combo",
    viewBox: "0 0 24 24",
    // 4-square Microsoft mark
    path:
      "M11.4 24H0V12.6h11.4V24zm12.6 0H12.6V12.6H24V24zm-12.6-12.6H0V0h11.4v11.4zm12.6 0H12.6V0H24v11.4z",
    wordmark: "Microsoft",
    wordmarkClassName: "font-display font-normal tracking-tight",
  },
  {
    name: "Oracle",
    type: "wordmark",
    text: "ORACLE",
    className: "font-display font-bold tracking-tight",
  },
  {
    name: "IBM",
    type: "wordmark",
    text: "IBM",
    className: "font-display font-black tracking-[0.15em] italic",
  },
  {
    name: "Cisco",
    type: "wordmark",
    text: "CISCO",
    className: "font-display font-semibold tracking-[0.2em]",
  },
  {
    name: "Marriott",
    type: "wordmark",
    text: "Marriott",
    // Marriott is known for a serif wordmark. Emulate a refined serif in monochrome.
    className: "font-serif tracking-wide italic",
  },
  {
    name: "The Children's Place",
    type: "wordmark",
    text: "The Children's Place",
    // A distinct rounded-feel wordmark.
    className: "font-display tracking-tight",
  },
];

function BrandMark({ brand }) {
  if (brand.type === "svg") {
    return (
      <svg
        viewBox={brand.viewBox}
        aria-hidden="true"
        role="img"
        className="h-8 md:h-9 w-auto text-white/70 group-hover:text-white transition-colors"
        fill="currentColor"
      >
        <path d={brand.path} />
      </svg>
    );
  }
  if (brand.type === "svg-combo") {
    return (
      <span className="inline-flex items-center gap-2.5 text-white/70 group-hover:text-white transition-colors">
        <svg
          viewBox={brand.viewBox}
          aria-hidden="true"
          role="img"
          className="h-7 md:h-8 w-auto"
          fill="currentColor"
        >
          <path d={brand.path} />
        </svg>
        <span
          className={`text-xl md:text-[24px] font-semibold leading-none whitespace-nowrap ${brand.wordmarkClassName || ""}`}
        >
          {brand.wordmark}
        </span>
      </span>
    );
  }
  if (brand.type === "wordmark") {
    return (
      <span
        aria-hidden="true"
        className={`text-white/70 group-hover:text-white transition-colors text-xl md:text-[26px] font-semibold leading-none whitespace-nowrap ${brand.className || ""}`}
      >
        {brand.text}
      </span>
    );
  }
  return null;
}

function BrandRow({ brands }) {
  return (
    <div className="xa-brand-track flex items-center shrink-0 gap-10 md:gap-16 pr-10 md:pr-16">
      {brands.map((b) => (
        <div
          key={b.name}
          className="group flex items-center gap-3 opacity-90 hover:opacity-100 transition-opacity"
          title={b.name}
        >
          <BrandMark brand={b} />
          <span className="sr-only">{b.name}</span>
        </div>
      ))}
    </div>
  );
}

export default function BrandExperience() {
  return (
    <section
      data-testid="brand-experience"
      aria-label="Brands the Xadentra team has worked with"
      className="relative bg-[#07111F] text-white border-t border-white/5 overflow-hidden"
    >
      {/* subtle depth */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#6D4DFF]/30 to-transparent pointer-events-none" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#00D4FF]/20 to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        {/* Header row */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 items-end">
          <Reveal className="lg:col-span-6">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#00D4FF]">
              Experience behind Xadentra
            </div>
            <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-[42px] font-bold tracking-tight leading-tight">
              Built on experience with leading global brands.
            </h2>
          </Reveal>
          <Reveal delay={120} className="lg:col-span-6">
            <p className="text-white/65 leading-relaxed text-[15px] max-w-xl lg:ml-auto">
              Our team brings hands-on experience delivering marketing
              technology, automation, digital operations, and transformation
              initiatives for leading global organizations across enterprise SaaS,
              hospitality, retail, and financial services.
            </p>
          </Reveal>
        </div>

        {/* Marquee */}
        <div
          className="mt-12 relative xa-brand-marquee-mask select-none"
          role="region"
          aria-label="Continuously scrolling brand references"
        >
          <div className="xa-brand-marquee flex w-max">
            <BrandRow brands={BRANDS} />
            <BrandRow brands={BRANDS} aria-hidden="true" />
            <BrandRow brands={BRANDS} aria-hidden="true" />
          </div>
        </div>

        {/* Clarification */}
        <p
          className="mt-10 text-xs md:text-[13px] text-white/45 font-mono uppercase tracking-[0.14em] max-w-3xl"
          data-testid="brand-experience-clarification"
        >
          Selected organizations our team has supported throughout their
          professional careers. Presented as team experience — not as current
          Xadentra customers, partners, or endorsers.
        </p>
      </div>
    </section>
  );
}
